import { useEffect, useRef } from 'react';

export function useMountStatus() {
    const mountStatusRef = useRef(false);

    useEffect(() => {
        mountStatusRef.current = true;

        return () => {
            mountStatusRef.current = false;
        };
    }, []);

    return mountStatusRef;
}
